var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BlBackdrop",
    { attrs: { footer: false, backdropClass: "overflow-hidden" } },
    [
      _c(
        "div",
        { staticClass: "flex", style: { height: "80vh", width: "80vw" } },
        [
          _c("div", { staticClass: "w-160 flex-shrink-0" }, [
            _c(
              "div",
              {
                staticClass:
                  "h-12 w-160 px-6 bg-slate-300 border-b border-slate-400 flex items-center gap-2"
              },
              [
                _c("BlTextBody2", {
                  attrs: {
                    text: _vm.displayDate({
                      date: _vm.overlapped.date,
                      format: "dddd, DD MMM"
                    })
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "h-1 w-1 flex-shrink-0 bg-slate-600 rounded"
                }),
                _vm._v(" "),
                _c("BlTextBody2", { attrs: { text: _vm.overlapped.room.name } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex flex-col relative bg-slate-200 overflow-y-auto scrollbar-lg",
                style: { height: "calc(80vh - 3rem)" }
              },
              [
                _vm._l(_vm.clockRound, function(time) {
                  return _c(
                    "div",
                    {
                      key: time,
                      staticClass: "flex",
                      attrs: { id: "time_view_" + time }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-20 py-2 px-3 flex-shrink-0 bg-slate-200 flex justify-end border-b border-r border-slate-400 transition-all duration-300",
                          style: { height: _vm.slotHeight * 2 + "rem" }
                        },
                        [_c("BlTextBody2", { attrs: { text: time } })],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "w-full flex flex-col gap-2 items-center justify-center border-b border-r border-slate-400 bg-slate-200 transition-all duration-300",
                        style: {
                          height: _vm.slotHeight * 2 + "rem"
                        }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _vm._l(_vm.availableTimeslots, function(item, idx) {
                  return _c("AvailableTimeslot", {
                    key: idx,
                    attrs: {
                      id: "overlapped-" + idx,
                      isCompact: true,
                      item: item,
                      order: idx,
                      slotHeight: _vm.slotHeight,
                      slotWidth: _vm.slotWidth,
                      selected: _vm.selectedAvailabilityId
                    },
                    on: {
                      "set-selected": function($event) {
                        return _vm.onSelectAvailabilityId($event)
                      }
                    }
                  })
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "h-full w-full flex flex-col items-center" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "h-full w-full max-w-152 px-10 flex flex-col justify-center gap-2"
                },
                [
                  _c("BlTextTitle4", {
                    attrs: { text: "Adjust conflicting timeslots" }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "There are 2 overlapping availability slots in"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: _vm.overlapped.room.name }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "on" } }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              _vm.displayDate({
                                date: _vm.overlapped.date,
                                format: "dddd, DD MMMM"
                              }) + ":"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      { staticClass: "list-inside list-disc" },
                      _vm._l(_vm.availableTimeslots, function(item, idx) {
                        return _c(
                          "li",
                          { key: idx },
                          [
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: { text: item.start_time_string }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: { text: "-" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: { text: item.end_time_string }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", { attrs: { text: "by" } }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              attrs: { text: item.therapist.name }
                            })
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _vm.bookedTimeslots.length === 2
                    ? _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: { text: "Resolve the" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text: _vm.bookedTimeslots[0].periods.length
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: { text: "appointment(s) for" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text: _vm.bookedTimeslots[0].therapist.name
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "font-bold",
                                attrs: { text: "or" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", { attrs: { text: "the" } }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text: _vm.bookedTimeslots[1].periods.length
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: { text: "appointment(s) for" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text: _vm.bookedTimeslots[1].therapist.name
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "before you can delete the conflicting availability slot."
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.bookedTimeslots, function(timeslot, idx) {
                            return _c(
                              "div",
                              { key: idx },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "px-5 py-2 bg-slate-200 rounded truncate"
                                  },
                                  [
                                    _c("BlTextSubtitle3", {
                                      staticClass: "truncate",
                                      attrs: { text: timeslot.therapist.name }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm._l(timeslot.periods, function(period) {
                                  return _c("ResolveAppointment", {
                                    key: period.id,
                                    attrs: { period: period },
                                    on: {
                                      "after-commit": function($event) {
                                        return _vm.$emit("after-commit")
                                      }
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bookedTimeslots.length === 1
                    ? _c("div", { staticClass: "flex flex-col gap-2" }, [
                        _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              attrs: {
                                text:
                                  "To resolve the conflict, we'll remove the availability slot with no appointments, which belongs to"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: {
                                text: _vm.selectedAvailability.therapist.name
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "font-bold",
                              attrs: {
                                text:
                                  "(" +
                                  _vm.selectedAvailability
                                    .overlapped_start_time +
                                  " - " +
                                  _vm.selectedAvailability.overlapped_end_time +
                                  ")."
                              }
                            })
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.bookedTimeslots.length
                    ? _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "To resolve the conflict, select the slot to delete from the calendar on the left."
                            }
                          }),
                          _vm._v(" "),
                          !_vm.selectedAvailabilityId
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "px-2 py-2 flex flex-col gap-2 bg-slate-200 border border-slate-300 rounded"
                                },
                                [
                                  _c("BlTextBody2", {
                                    attrs: { text: "No timeslot selected." }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "px-2 py-2 flex flex-col gap-2 bg-slate-200 border border-slate-300 rounded"
                                },
                                [
                                  _c("BlTextBody2", {
                                    attrs: {
                                      text: "Selected slot to be deleted:"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center gap-1" },
                                    [
                                      _c("BlIcon", {
                                        staticClass: "h-4 w-4",
                                        attrs: {
                                          icon: "user",
                                          color: "slate-6"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextBody2", {
                                        attrs: {
                                          text:
                                            _vm.selectedAvailability.therapist
                                              .name
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "flex items-center gap-1" },
                                    [
                                      _c("BlIcon", {
                                        staticClass: "h-4 w-4",
                                        attrs: {
                                          icon: "clock",
                                          color: "slate-6"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextTitle4", {
                                        attrs: {
                                          text:
                                            _vm.selectedAvailability
                                              .overlapped_start_time
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextTitle4", {
                                        attrs: { text: "-" }
                                      }),
                                      _vm._v(" "),
                                      _c("BlTextTitle4", {
                                        attrs: {
                                          text:
                                            _vm.selectedAvailability
                                              .overlapped_end_time
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedAvailability &&
                  _vm.selectedAvailability.availability &&
                  _vm.selectedAvailability.availability.repetition_type !==
                    "not_repeat"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex items-start gap-2 p-2 bg-cornflower-200 rounded"
                        },
                        [
                          _c("BlIcon", {
                            staticClass: "w-4 mt-1",
                            attrs: { icon: "info", color: "cornflower-8" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "break-words" },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-cornflower-800 break-words",
                                attrs: {
                                  text:
                                    "You've adjusted a recurring slot, but this change applies only to this one."
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-cornflower-800 break-words",
                                attrs: {
                                  text:
                                    "To update all remaining slots, please go to the"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to:
                                      "/availabilities?date=" +
                                      _vm.overlapped.date +
                                      "&type=daily"
                                  }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass:
                                      "text-cornflower-800 break-words font-bold underline",
                                    attrs: { text: "Availabilities" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "text-cornflower-800 break-words",
                                attrs: { text: "page." }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "h-24 w-full max-w-152 px-10 pt-4 grid grid-cols-4 items-start flex-shrink-0 gap-4"
                },
                [
                  _c("BlInputButton", {
                    attrs: { label: "Cancel", type: "plain" },
                    on: {
                      clicked: function($event) {
                        return _vm.$emit("close-modal")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("BlInputButton", {
                    staticClass: "col-span-3",
                    attrs: {
                      label: "Delete selected slot",
                      type: "error",
                      disabled: !_vm.selectedAvailabilityId,
                      loading: _vm.submitLoading
                    },
                    on: { clicked: _vm.onSubmit }
                  })
                ],
                1
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d5eb796", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d5eb796","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/overlapped/ResolveOverlappedModal.vue
// module id = null
// module chunks = 